<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { stopBackSpace } from '@/utils/preventBackspace';
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  mounted() {
    //document.onkeypress = stopBackSpace;
    //document.onkeydown = stopBackSpace;
  }
};
</script>
<style lang="scss">
#app {
  height: 100%;
}
</style>
